import Immutable from 'seamless-immutable';
import _ from 'underscore';

const initialState = Immutable({user:{},token:false});


export default (state = initialState, action) => {
  console.log('initialState', action);
  switch (action.type) {
    case "SET_TOKEN":
      localStorage.setItem("ef_token", action.token);
      return state.merge({ token: action.token });
    case "SET_USER":
      return state.merge({ user: action.user });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/index.js